<template>
  <div>
    <div class="eu-display_flex footer-container eu-align-items_center">
      <div class="eu-justify_center footer-information">
        <span
          id="userName"
          class="account-name"
          :title="profile.user.first_name"
        >
          {{ profile.user.first_name }} {{ profile.user.last_name }}</span
        >
        <span
          id="userEmail"
          class="account-email"
          :title="profile.user.email"
          >{{ profile.user.email }}</span
        >
      </div>
      <div
        class="emd-dropdown _position_left jsDropdown"
        data-onboarding="profile"
      >
        <emd-dropdown
          class="popover"
          :isOpen="selectOpenned"
          :fixed="false"
          @toggle="selectOpenned = $event"
          @close="selectOpenned = false"
        >
          <template #trigger>
            <span>
              <emd-tippy
                class="emd-action-button _has-tooltip popover-trigger"
                id="settings"
                :type="'ghost'"
                :position="'left'"
                :content="$t('tooltip.settings')"
              >
                <emerald-icon icon="ellipsis" />
              </emd-tippy>
            </span>
          </template>
          <template>
            <div class="emd-dropdown__content__item popover-items">
              <ul>
                <li
                  v-for="item in popoverItems"
                  :key="item.title"
                >
                  <button
                    class="popover-button"
                    @click="item.action"
                  >
                    {{ item.title }}
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </emd-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { EmdTippy, EmdDropdown, EmeraldIcon } from 'emerald-vue/src/components'
import { ITEMS_POPOVER } from './app-core-popover.enum'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppCoreFooter',
  components: {
    EmdDropdown,
    EmeraldIcon,
    EmdTippy
  },
  data () {
    return {
      selectOpenned: false
    }
  },
  computed: {
    ...mapGetters(['isEmployee', 'profile', 'merchant']),

    popoverItems () {
      return ITEMS_POPOVER(this.isEmployee, {
        merchantId: this.merchant.id,
        toggleGlobalLoading: this.toggleGlobalLoading,
        DELETE_AUTHORIZATION: this.DELETE_AUTHORIZATION
      }).map(item => ({
        ...item,
        title: this.$t(item.title)
      }))
    }
  },
  methods: {
    ...mapActions(['toggleGlobalLoading', 'DELETE_AUTHORIZATION'])
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "tooltip": {
        "settings": "Configurações"
      }
    },
    "en-US": {
      "tooltip": {
        "settings": "Settings"
      }
    }
  }
</i18n>

<style>
.footer-container {
  height: 64px;
  margin: 0 16px;
  border-top: 1px solid var(--gray-50-squanchy);
}
.account-name {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.account-email {
  font-size: 12px;
  color: #8b8b92;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.footer-information {
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  width: calc(100% - 32px);
}
.footer-button {
  padding: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.popover .emd-dropdown__content {
  bottom: 0;
  left: 56px;
}

.popover-button {
  height: 40px;
  padding: 8px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 14px;
  width: 100%;
  font-weight: bold;
  color: var(--gray-600-birdperson);
}

.popover-button:hover {
  background-color: var(--gray-50-squanchy);
  border-radius: 8px;
}

.popover-items {
  display: flex;
  flex-direction: column;
  padding: 8px;
}

.popover .emd-dropdown__content:after {
  content: ' ';
  position: absolute;
  bottom: 14px;
  left: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fff;
}
</style>
